'use client';

import { AUTO_REPLIES_FORM_TITLE } from '@/components/auto-replies-copy';
import { UIPriority } from '@/enums/ui-priorities';
import Button from '@/ui/Button';
import { FC } from 'react';

type SettingsRefreshButtonsViewProps = {
    openSettingsModal: () => void;
    openAutoRepliesModal: () => void;
    openSelectedAutoRepliesModal?: () => void;
    openAnswerTemplatesEditor?: () => void;
    showAutoRepliesButton?: boolean;
    showAnswerTemplatesButton?: boolean;
    isSelectedAutoRepliesRunEnabled?: boolean;
};

export const SettingsRefreshButtonsView: FC<SettingsRefreshButtonsViewProps> = ({
    openSettingsModal,
    openAutoRepliesModal,
    openSelectedAutoRepliesModal,
    openAnswerTemplatesEditor,
    showAutoRepliesButton = false,
    showAnswerTemplatesButton = false,
    isSelectedAutoRepliesRunEnabled = false,
}) => {
    const onAutoRepliesClick = () => {
        if (isSelectedAutoRepliesRunEnabled) {
            openSelectedAutoRepliesModal?.();
            return;
        }

        openAutoRepliesModal();
    };

    return (
        <div className="flex items-center gap-2">
            {showAutoRepliesButton ? (
                <Button
                    type="button"
                    className="w-32 max-w-32 whitespace-nowrap !p-[5px]"
                    priorityType={isSelectedAutoRepliesRunEnabled ? UIPriority.PRIMARY : UIPriority.SECONDARY}
                    uiSize="compact"
                    onClick={onAutoRepliesClick}
                >
                    {AUTO_REPLIES_FORM_TITLE}
                </Button>
            ) : null}
            {showAnswerTemplatesButton ? (
                <Button
                    type="button"
                    className="w-28 max-w-28 whitespace-nowrap !p-[5px]"
                    priorityType={UIPriority.SECONDARY}
                    uiSize="compact"
                    onClick={() => void openAnswerTemplatesEditor?.()}
                >
                    Шаблоны
                </Button>
            ) : null}
            <Button
                type="button"
                className="w-32 max-w-32 whitespace-nowrap !p-[5px]"
                priorityType={UIPriority.SECONDARY}
                uiSize="compact"
                onClick={openSettingsModal}
            >
                Настройки
            </Button>
        </div>
    );
};
